<template>
    <q-page>
        <div class="q-pa-md">
            <div class="text-h4">Justificación Global</div>
            <div class="row">
                <div class="col-md-4">
                    <q-input class="m-3" outlined dense v-model="fecha" label="Fecha" mask="date"  :rules="['date']"  @update:model-value="busqueda()">
                    <template v-slot:append>
                        <q-icon name="event" class="cursor-pointer">
                            <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                                <q-date v-model="fecha" :locale="myLocale" @update:model-value="busqueda()">
                                    <div class="row items-center justify-end">
                                        <q-btn v-close-popup label="Cerrar" color="primary" flat />
                                    </div>
                                </q-date>
                            </q-popup-proxy>
                        </q-icon>
                    </template>
                </q-input>
                </div>
            </div>
            
            <table class="q-table">
                <thead>
                    <tr class="q-tr bg-dark text-white">
                        <th class="" align="left">Descripción</th>
                        <th class="" align="left">Justificación</th>
                    </tr>
                </thead>
                <tbody class="q-virtual-scroll__padding">
                    <tr>
                        <td colspan="6" style="height: 0px; --q-virtual-scroll-item-height:28px;"></td>
                    </tr>
                </tbody>
                <tbody class="q-virtual-scroll__content"  tabindex="-1">
                    <tr class="q-tr" v-for="(item,index) in justificacion.Incidencias">
                        <td class="q-td ">{{item.Descripcion}}</td>
                        <td class="q-td ">
                            <q-select outlined option-value="IdIncidencia" option-label="Descripcion" dense v-model="justificacion.Incidencias[index].IdJustificacion" :options="catinci" option-disable="inactive" emit-value map-options label="Incidencia" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <q-form class="q-gutter-md" @submit.prevent="guardar">
                <q-input :disable="!justificacion.Incidencias.length>0" class="m-3" outlined dense v-model="justificacion.Observaciones" label="Observaciones" type="textarea"  :rules="rules"/>
                <q-btn :disable="!justificacion.Incidencias.length>0" color="primary" label="Guardar" type="submit"/>
            </q-form>

        </div>
    </q-page>
</template>

<script>
import http from "@/services/http"
import rs from '@/services/routerStore';

export default {
    data:()=> ({
        fecha: new Date().getFullYear()+'/'+String(new Date().getMonth()+1).padStart(2,'0')+'/'+String(new Date().getDate()).padStart(2,'0'),
        justificacion:{},
        catinci:[],
         myLocale: {
        days: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
        daysShort: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb'.split('_'),
        months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
        monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
        firstDayOfWeek: 1
      },
      rules: [v => !!v || 'Campo obligatorio',],
    }),
    methods:{
        async busqueda(){
            var fecha = new Date(this.fecha)
            var dia = fecha.getDate();
            var mes = fecha.getMonth()+1;
            var eje = fecha.getFullYear();
            this.justificacion = await http.get(`calendario/festivos/justificacion/${dia}/${mes}/${eje}`)
        },
        async cargaCatIncidencia(){
            this.catinci = await http.get('catalogos/incidencias');
        },
        async guardar(){
            await http.post('calendario/festivos/justificacion',this.justificacion)
            rs.alert({color:'positive', message:'Datos Guardados'})
            this.busqueda()
        },
        getFecha(fecha){
            return fecha.getFullYear()+'/'+String(fecha.getMonth()+1).padStart(2,'0')+'/'+String(fecha.getDate()).padStart(2,'0');
        },
    },
    created(){
        this.cargaCatIncidencia()
        this.busqueda();
    }
}
</script>